import { Middleware } from "redux";
import { AppState } from "../redux/AppTypes";
import {
  CustomerAction as BaseAction,
  FETCH_CUSTOMERS as FETCH,
  LOAD_CUSTOMERS as LOAD,
  LoadCustomersAction as LoadAction,
  REMOVE_CUSTOMER as REMOVE,
  REMOVE_CUSTOMER_LOCAL,
  PERSIST_CUSTOMER as PERSIST,
  UPSERT_CUSTOMER,
} from "./CustomerTypes";
import service from "./CustomerService";

const fetchMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === FETCH) {
    const page = action.paginated
      ? await service.fetchPage({
          limit: action.limit,
          nextToken: action.nextToken,
        })
      : undefined;
    const items = page ? page.items : await service.fetch();

    items.sort((i1, i2) =>
      i1.name.toLowerCase().localeCompare(i2.name.toLowerCase())
    );

    const load: LoadAction = {
      type: LOAD,
      append: action.append,
      items,
      loadedAll: page ? !page.nextToken : true,
      nextToken: page?.nextToken,
    };
    store.dispatch(load);
    return items;
  } else {
    return result;
  }
};

const deleteMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === REMOVE) {
    await service.delete(action.id);
    store.dispatch({ type: REMOVE_CUSTOMER_LOCAL, id: action.id });
    return action.id;
  } else {
    return result;
  }
};

const persistMiddleware: Middleware<{}, AppState> = (store) => (next) => async (
  action: BaseAction
) => {
  const result = next(action);
  if (action.type === PERSIST) {
    const item = await service.persist(action.item);
    store.dispatch({ type: UPSERT_CUSTOMER, item });
    return item;
  } else {
    return result;
  }
};

const middlewares = [
  fetchMiddleware,
  deleteMiddleware,
  persistMiddleware,
];
export default middlewares;
